import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUploadFileContext } from '../../../../context/UploadFileContext';
import { useGeneralContext } from '../../../../context/GeneralContext';
import { useConfirmation } from '../../../../context/ConfirmationContext';
import { useLocationsCacheContext } from '../../../../context/LocationsCacheContext';
import { delCRUD } from '../../../../services/crudService';

const useDeleteAsset = ({ refetch } = {}) => {
  const { t } = useTranslation();
  const { openToast } = useGeneralContext();
  const { openConfirmation } = useConfirmation();
  const { refreshMap } = useLocationsCacheContext();
  const { deleteFile } = useUploadFileContext();
  const [delLoading, setDelLoading] = useState(false);

  const handleDelete = asset => {
    setDelLoading(true);
    delCRUD({ entity: 'asset', id: asset.id })
      .then(async () => {
        if (!asset.image.includes('assetType/')) {
          await deleteFile(asset.image, 'asset/images', asset.id);
        }
        await refetch?.();
        refreshMap();
        openToast(
          t('management_menu.asset_management.validation.delete_success'),
        );
      })
      .catch(err => {
        console.error(err);
        openToast(
          t('management_menu.asset_management.validation.delete_error'),
          'error',
        );
      })
      .finally(() => setDelLoading(false));
  };

  const handleDeleteConfirmation = asset => {
    openConfirmation({
      message: (
        <span>
          {t('management_menu.asset_management.delete_modal.description_1')}
          <b style={{ fontWeight: 'bold' }}>{asset.name}</b>
          {t('management_menu.asset_management.delete_modal.description_2')}
        </span>
      ),
      title: t('management_menu.asset_management.delete_modal.title'),
      handleAction: handleDelete,
    });
  };

  return { handleDelete, delLoading, handleDeleteConfirmation };
};

export default useDeleteAsset;
